import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../Context/useAuth";
import { dataContext } from "../Context/contextProvider";
import { observer } from "mobx-react";

type Props = {
  children: React.ReactNode;
  checkLoginProp?: string | string[];
};
const ProtectedRoute = observer(({ children, checkLoginProp }: Props) => {
  const location = useLocation();
  const dataStore = useContext(dataContext);
  const { isAuthenticated, isRefreshing, isAllowed } = useAuth();

  const isAllowedLocal = (permissions?: string | string[]): boolean => {
    if (permissions === undefined) {
      return true;
    }
    let perms = [];
    if (!Array.isArray(permissions)) {
      perms = [permissions];
    } else {
      perms = permissions;
    }
    for (const perm of perms) {
      if (isAllowed(dataStore.serverUrl!, dataStore.dbKey!, perm)) {
        return true;
      }
    }
    return false;
  };
  if (isAuthenticated() && isAllowedLocal(checkLoginProp)) {
    return <>{children}</>;
  } else if (!isRefreshing()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  } else {
    return <>Refreshing token...</>;
  }
});

export default ProtectedRoute;
